var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00830078H513V341.995H0V-0.00830078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 267.175C309.623 267.175 352.688 224.111 352.688 170.988C352.688 117.865 309.623 74.8005 256.5 74.8005C203.377 74.8005 160.312 117.865 160.312 170.988C160.312 224.111 203.377 267.175 256.5 267.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.35 134.213L284.852 156.953L311.577 148.287L295.049 171.007L311.549 193.746L284.833 185.048L268.306 207.769L268.323 179.674L241.606 170.975L268.333 162.31L268.35 134.213Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.361 227.829C246.97 227.829 221.523 202.382 221.523 170.991C221.523 139.6 246.97 114.153 278.361 114.153C288.149 114.153 297.358 116.628 305.399 120.985C292.785 108.651 275.536 101.038 256.5 101.038C217.867 101.038 186.546 132.358 186.546 170.992C186.546 209.626 217.867 240.946 256.5 240.946C275.536 240.946 292.786 233.333 305.399 220.998C297.357 225.354 288.149 227.829 278.361 227.829Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00634766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/TN.6d6ff1a20cad3ec5c56503fbadefa8bd.svg";
export { ForwardRef as ReactComponent };